import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faUsers, faCalendarAlt, faUtensils, faChartBar, faCog, faSignOutAlt, faBars, faTimes, faComments } from '@fortawesome/free-solid-svg-icons';
import { useAuthentication } from '@features/auth/useAuthentication.ts';

interface MenuItem {
  id: string;
  label: string;
  icon: any;
  href: string;
  active?: boolean;
}

interface AdminMenuProps {
  className?: string;
}

const AdminMenu: React.FC<AdminMenuProps> = ({ className = '' }) => {
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const { logout } = useAuthentication();

  const menuItems: MenuItem[] = [
    { id: 'dashboard', label: 'Dashboard', icon: faTachometerAlt, href: '/admin', active: true },
    { id: 'users', label: 'Uživatelé', icon: faUsers, href: '/admin/users' },
    { id: 'reservations', label: 'Rezervace', icon: faCalendarAlt, href: '/admin/reservations' },
    { id: 'restaurants', label: 'Restaurace', icon: faUtensils, href: '/admin/restaurants' },
    { id: 'analytics', label: 'Analytika', icon: faChartBar, href: '/admin/analytics' },
    { id: 'whatsapp', label: 'WhatsApp', icon: faComments, href: '/admin/whatsapp' },
    { id: 'settings', label: 'Nastavení', icon: faCog, href: '/admin/settings' },
  ];

  return (
    <>
      {/* Mobile menu button */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button onClick={() => setIsCollapsed(!isCollapsed)} className="bg-white p-2 rounded-md shadow-md border border-gray-200">
          <FontAwesomeIcon icon={isCollapsed ? faBars : faTimes} className="w-5 h-5 text-gray-600" />
        </button>
      </div>

      {/* Overlay for mobile */}
      {isCollapsed && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30" onClick={() => setIsCollapsed(false)} />}

      {/* Sidebar */}
      <aside
        className={`
        ${isCollapsed ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        fixed lg:static inset-y-0 left-0 z-40 w-64 bg-white shadow-lg border-r border-gray-200
        transition-transform duration-300 ease-in-out lg:transition-none
        ${className}
      `}
      >
        <div className="flex flex-col h-full">
          {/* Logo/Brand */}
          <div className="flex items-center justify-center h-16 px-4 bg-blue-600">
            <h2 className="text-xl font-bold text-white">Reservare</h2>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2">
            {menuItems.map(item => (
              <a
                key={item.id}
                href={item.href}
                className={`
                  flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                  ${item.active ? 'bg-blue-100 text-blue-700 border-r-2 border-blue-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}
                `}
              >
                <FontAwesomeIcon icon={item.icon} className="w-5 h-5 mr-3" />
                <span>{item.label}</span>
              </a>
            ))}
          </nav>

          {/* Logout */}
          <div className="p-4 border-t border-gray-200">
            <button onClick={logout} className="flex items-center px-3 py-2 text-sm font-medium text-red-600 rounded-md hover:bg-red-50 transition-colors">
              <FontAwesomeIcon icon={faSignOutAlt} className="w-5 h-5 mr-3" />
              <span>Odhlásit se</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminMenu;
